import { Reservation } from './model/Reservation';
import { Restaurant } from './model/Restaurant';
import { Course } from './model/Course';
import * as React from 'react';
import styled from 'styled-components';
import Header from './Header';
import Footer from './Footer';
import { messages, lang} from './i18n';
import { IntlProvider, FormattedDate, FormattedTime } from 'react-intl';
import { media } from './style-utils';

export interface Props {
  restaurant: Restaurant;
  reservation: Reservation;
  authToken: string;
  id: string;
  phone: string;
}

export interface State {
  locale: string;
  messages: Object;
  startCancel: boolean;
}

export const Form = styled.form`
  margin: 32px auto 15px auto;
  width: 656px;
  border-radius: 4px;
  background-color: #ffffff;
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.3);
  padding-top: 0px;
  padding-bottom: 32px;
  text-align: center;
  ${media['tablet'] `
    width: 100%;
    margin: 32px 0px;
  `}
  ${media['phone'] `
    margin: 0px;
    width: 100%;
    box-shadow: initial;
    padding-bottom: 20px;
    background-color: transparent
  `}
`;

export const ErrorText = styled.p`
  font-size: 13px;
  color: #ee0000;
  text-align: center;
  margin-top: 25px;
  ${media['phone'] `
    margin-top: 20px;
  `}
`;

const Wrapper = styled.div`

`;

const CancelText = styled.p`
  padding-top: 15px;
  font-size: 13px;
  text-align: center;
  background-color: #bbb;
  color: #fff;
  height: 27px;
  margin: 0px;
  ${media['phone']`
    position: relative;
    top: 20px;
    width: calc(100% - 24px);
    margin: 0px 12px;
    border-top-right-radius: 4px;
    border-top-left-radius: 4px;
  `}
`;

const DataSection = styled.div`
  padding-top: 32px;
  margin: 0px 32px;
  text-align: left;
  background-color: #fff;
  ${media['phone'] `
    border: 1px solid #555;
    border-radius: 4px;
    &.restaurant {
      margin: 16px 12px 0px 12px;
      padding: 20px 18px 0px 18px;
      border-bottom: 0px;
      border-bottom-right-radius: 0px
      border-bottom-left-radius: 0px
    }
    &.reservation {
      margin: 0px 12px;
      padding: 20px 18px;
      border-top: 0px;
      border-top-right-radius: 0px
      border-top-left-radius: 0px
    }
  `}
`;
const SectionName = styled.h2`
  font-size: 14px;
  color: #333;
  padding-bottom: 8px;
  margin: 0px;
  border-bottom: 1px solid #ccc;
  ${media['phone'] `
    border: 0px;
    padding: 0px;
  `}  
`;
const SectionData = styled.div`
  font-size: 14px;
  border-bottom: 1px solid #ccc;
  padding: 8px 0px;
  & > label {
    vertical-align: top;
    color: #999;
    display: inline-block;
    width :140px;
    margin-left: 24px;
    ${media['phone'] `
      margin: 0px;
      margin-bottom: 3px;
      width: initial;
      font-size: 9px;
      position: initial;
    `}

  }
  div {
    display: inline-block;
    width: calc(100% - 170px);
    ${media['phone'] `
      display: block;
      width: initial;
      margin: 0px;
    `}
    p {
      margin: 0px;
      color: #333;
    }
    }
  ${media['phone'] `
    border: 0px;
    padding: 6px 0px;
  `}  
`;

const TextSection = styled.p`
  margin: 15px auto 0px auto;
  width: 400px;
	font-size: 12px;
	line-height: 1.67;
	text-align: center;
	color: #333333;
  ${media['phone'] `
    width: initial;
    margin: 12px;
    text-align: left;
  `}
`;

const CancelButton = styled.button`
  background-color: transparent;
  cursor: pointer;
  height: 48px;
  color: #000;
  border: 1px solid #333;
  border-radius: 3px;
  background-color: transparent;
  &.yes {
    margin: 20px 0px 0px 32px;
    width: calc(50% - 36px);
    ${media['phone']`
      margin: 0px 0px 0px 12px;
      width: calc(50% - 16px);
    `}
  }
  &.no {
    margin: 20px 32px 0px 8px;
    width: calc(50% - 36px);
    ${media['phone']`
      margin: 0px 12px 0px 8px;
      width: calc(50% - 16px);
    `}
  }
`;

const FormButton = styled.button`
  cursor: pointer;
  margin: 24px auto 0px auto;
  width: 296px;
  ${media['phone']`
    width: calc(100% - 24px);
  `}
  height: 48px;
  color: #000;
  border: 1px solid #333;
  border-radius: 3px;
  background-color: transparent;
`;

class Confirmation extends React.Component<Props, State> {
  restaurant: Restaurant;
  reservagtion: Reservation;
  cancelButton: HTMLButtonElement;  
  constructor(props: Props, state: State) {
    super(props);
    this.state = {
      locale: lang,
      messages: messages[lang],
      startCancel: false
    };
  }
  render () {
    const intlProvider = new IntlProvider(
      { locale: this.state.locale, messages: this.state.messages}, {});
    const { intl } = intlProvider.getChildContext();
    const {restaurant, reservation, authToken, id, phone} = this.props;
    const cancelText = (reservation.canceled && reservation.cancel) ? intl.formatMessage({id: 'reservationCancel'})
                                           : (reservation.canceled) ? intl.formatMessage({id: 'reservationCanceled'})
                                           : '';
    let courseElements: JSX.Element[] = [];
    (reservation.courses || []).forEach((course: Course, index: number) => {
      courseElements.push(<p key={course.key}>{course.name} {(course.formated_price) ? course.formated_price : ''} × {course.count}{intl.formatMessage({id: 'people'})}</p>);
    });
    const month = reservation.month - 1;
    const startHour = Math.floor(reservation.start_time / 3600);
    const startMinutes = Math.floor(reservation.start_time % 3600 / 60);
    const startDate = new Date(reservation.year, month, reservation.date, startHour, startMinutes);
    let adultsNum = reservation.adults_max + reservation.adults_min;
    let childrenNum = reservation.children_max + reservation.children_min;
    let adultsNumStr = (adultsNum > 0 || childrenNum > 0) ? (reservation.adults_max > reservation.adults_min) ? `${reservation.adults_min}〜${reservation.adults_max}` : `${reservation.adults_max}` : null;
    let childrenNumStr = (adultsNum > 0 || childrenNum > 0) ? (reservation.children_max > reservation.children_min) ? `${reservation.children_min}〜${reservation.children_max}` : `${reservation.children_max}` : null;
    let seatsNumStr = (reservation.seats_max > reservation.seats_min) ? `${reservation.seats_min}〜${reservation.seats_max}` : `${reservation.seats_max}`;
    let seatElement: JSX.Element = <p>{seatsNumStr}{intl.formatMessage({id: 'people'})} {(adultsNumStr !== null) ? `(${intl.formatMessage({id: 'adults'})} ${adultsNumStr}${intl.formatMessage({id: 'people'})}, ${intl.formatMessage({id: 'children'})} ${childrenNumStr}${intl.formatMessage({id: 'people'})})` : ''}</p>;

    const tableCategory = (reservation.table_category) ? <p>{intl.formatMessage({id: reservation.table_category})}</p> : '';
    const doCancel = ( evt: React.MouseEvent<HTMLButtonElement>) => {
      evt.preventDefault();
      this.setState({ startCancel: !this.state.startCancel});
    };

    return (
      <IntlProvider
        locale={this.state.locale}
        messages={this.state.messages}
      >
        <Wrapper>
          <Header />
          <Form action="/-/cancel_exec" method="post" acceptCharset="UTF-8">
            <input type="hidden" name="authenticity_token" value={authToken} />
            <input type="hidden" name="id" value={id} />
            <input type="hidden" name="phone_no" value={phone} />
            <CancelText hidden={!cancelText}>{cancelText}</CancelText>
            <DataSection className="restaurant">
              <SectionName>{restaurant.name}</SectionName>
              <SectionData>
                <label>{intl.formatMessage({id: 'address'})}</label>
                <div><p><a href={`https://maps.google.com/maps?q=${encodeURIComponent(restaurant.address)}`} target="_blank">{restaurant.address}</a></p></div>
              </SectionData>
              <SectionData>
                <label>{intl.formatMessage({id: 'phone'})}</label>
                <div><p>{restaurant.phone}</p></div>
              </SectionData>
            </DataSection>
            <DataSection className="reservation">
              <SectionName>{intl.formatMessage({id: 'contents'})}</SectionName>
              <SectionData>
                <label>{intl.formatMessage({id: 'date'})}</label>
                <div><p><FormattedDate value={startDate} year="numeric" month="short" day="2-digit" weekday="short" /> <FormattedTime value={startDate} /> {intl.formatMessage({id: 'start'})}</p></div>
              </SectionData>
              <SectionData>
                <label>{intl.formatMessage({id: 'seats'})}</label>
                <div>{seatElement}</div>
              </SectionData>
              <SectionData hidden={!reservation.table_category}>
                <label>{intl.formatMessage({id: 'table_category'})}</label>
                <div>{tableCategory}</div>
              </SectionData>
              <SectionData hidden={!courseElements.length}>
                <label>{intl.formatMessage({id: 'course'})}</label>
                <div>{courseElements}</div>
              </SectionData>
              <SectionData>
                <label>{intl.formatMessage({id: 'reservationNumber'})}</label>
                <div><p>#{reservation.number}</p></div>
              </SectionData>
              <SectionData hidden={!reservation.deposit}>
                <label>{intl.formatMessage({id: 'deposit'})}</label>
                <div><p>{reservation.deposit}</p></div>
              </SectionData>
            </DataSection>
            <TextSection hidden={!(!reservation.canceled && !reservation.cancel)} >
              {intl.formatMessage({id: 'noText'})}
            </TextSection>
            <FormButton hidden={((!reservation.cancel || reservation.canceled) || this.state.startCancel)} onClick={(e) => doCancel(e)}>
              {intl.formatMessage({id: 'cancelButton'})}
            </FormButton>
            <div hidden = {!this.state.startCancel}>
              <TextSection>
                {intl.formatMessage({id: 'doCancel'})}
              </TextSection>
              <CancelButton innerRef={(button: HTMLButtonElement) => this.cancelButton = button} className="yes" name="submit_yes">
                {intl.formatMessage({id: 'yes'})}
              </CancelButton>
              <CancelButton onClick={(e) => doCancel(e)} className="no">
                {intl.formatMessage({id: 'no'})}
              </CancelButton>
            </div>
          </Form>
          <Footer country={restaurant.country} />
        </Wrapper>
      </IntlProvider>
    );
  }
}
export default Confirmation;



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/Confirmation.tsx